var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart-card',{attrs:{"title":"공중(다중)이용시설 안전·보건 예산 현황","value":_vm.data,"donut-value":_vm.donutValue,"donut-unit":_vm.donutUnit,"total":_vm.total,"unit":"원","isMoveWrite":_vm.isMoveWrite,"orientation":_vm.orientation},on:{"detail":_vm.onClickDetail,"write":_vm.onClickWrite}})
}
var staticRenderFns = []

export { render, staticRenderFns }